<script setup lang="ts">
import { XIcon } from "~/icons";
import { usePageStore } from "~/stores";

defineProps<{
  selected?: boolean;
  internal?: boolean;
}>();

const emit = defineEmits<{
  remove: [];
}>();

const pageStore = usePageStore();
</script>

<template>
  <div
    v-if="!pageStore.isMobile && selected"
    class="flex cursor-pointer items-center justify-center rounded-sm"
    :class="internal ? 'hover-bg-quiet' : 'hover:bg-hvy'"
    @click.stop="emit('remove')"
    @keydown.enter.stop="emit('remove')">
    <XIcon class="icon-xs" :class="!internal && 'text-md'" />
  </div>
</template>
